<template>
    <div>
        <div class="formSubmit">
            <vForm class="clearfix" v-model="formData" ref="dataForm">
                <vCol span="24">
                    <compWrapper title="测算原件" theme="primary">
                        <vButton
                            class="margin-top-15 margin-left-15"
                            theme="primary"
                            @click="adddocument"
                            >添加原件</vButton
                        >
                        <span class="margin-left-10 color-error"
                            >最多传5个原件，超过请压缩后再上传</span
                        >

                        <vTable
                            class="margin-15"
                            :columns="doccolumns"
                            :data="docList"
                            size="small"
                            ref="tablequery"
                            border
                        ></vTable>
                    </compWrapper>
                </vCol>
                <vCol span="24">
                    <compWrapper title="测算结果" theme="info">
                        <compMutiUpload
                            v-bind="getFileProps"
                            @on-cancel="close"
                            @on-success="success"
                        />
                    </compWrapper>
                </vCol>
            </vForm>
            <!-- 全局弹框 -->
            <compModal
                v-model="modalProps.show"
                v-bind="modalProps"
                @on-close="closemodalprops"
            >
                <component
                    ref="cusref"
                    :is="modalProps.component"
                    v-bind="modalProps"
                    v-on="modalProps.on"
                ></component>
            </compModal>
        </div>
        <vLoading loading size="large" transfer v-if="loading"></vLoading>
    </div>
</template>

<script>
import { HttpDelAttachNew } from "@/service/purchase/purchase";
export default {
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compMutiUpload: () => import("@components/templates/mutiUpload"),
        compModal: () => import("@components/templates/modal"), // 添加模态框组件
    },
    data() {
        return {
            loading: false,
            formData: {},
            docList: [],
            modalProps: {
                show: false,
                title: "",
                component: null,
            },
        };
    },
    created() {},
    computed: {
        doccolumns() {
            // let array =
            let _this = this;
            return [
                {
                    title: "附件名称",
                    key: "attachTitle",
                    render: (h, { row }) => {
                        return (
                            <a href={row.attachUrl} target="_blank">
                                {row.attachTitle}
                            </a>
                        );
                    },
                },
                {
                    title: "操作时间",
                    key: "attachOpAt",
                },
                {
                    title: "操作人",
                    key: "createdName",
                },
                {
                    title: "操作",
                    // width: 140,
                    render(h, { row, index }) {
                        let delButton = "";
                        if (_this.type !== "query") {
                            delButton = h(
                                "vButton",
                                {
                                    props: {
                                        theme: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove(index);
                                        },
                                    },
                                    style: {
                                        "margin-right": "15px",
                                    },
                                },
                                "删除"
                            );
                        }
                        return h("div", [
                            delButton,
                            h(
                                "vButton",
                                {
                                    props: {
                                        theme: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.downfile(row.attachUrl);
                                        },
                                    },
                                },
                                "下载"
                            ),
                        ]);
                    },
                },
            ];
        },
        getFileProps() {
            let attachment = JSON.stringify(this.docList);
            return {
                action:
                    process.env.VUE_APP_APIURL_BOSS +
                    "/api/v2/calculationReleaseProduct/importDataByCalculationResult",
                name: "excelFile",
                multiple: false,
                formatter: (res) => {
                    return this.$VMessage.warning("导入成功");
                },
                data: {
                    contextId: global.SYSID,
                    attachment: attachment,
                },
                download: () => {
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_BOSS +
                            "/api/v2/calculationReleaseProduct/importTemplateByCalculationResult",
                        {},
                        "download"
                    );
                },
            };
        },
    },
    methods: {
        closemodalprops() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        adddocument() {
            this.modalProps = {
                show: true,
                title: "添加附件",
                width: 460,
                component: "compMutiUpload",
                data: {
                    srcLabel: this.id || 0,
                    model: "changeLabel",
                    type: "other",
                },
                showFooter: false,
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: true,
                beforeUpload: (fileList) => {
                    if (fileList.length > 5) {
                        this.$VMessage.error("附件数量过多，请打包后上传");
                        return false;
                    } else {
                        return true;
                    }
                },
                on: {
                    "on-success": (res) => {
                        res.items.map((item) => {
                            this.docList.push(item);
                        });
                        window.console.log("this.docList", this.docList);
                        this.modalProps = {};
                    },
                    "on-cancel": () => {
                        this.modalProps = {};
                    },
                },
            };
        },
        downfile(url) {
            this.handleWebfs(url, {}, "download");
        },
        remove(index, useId) {
            HttpDelAttachNew({
                id: useId ? index : this.docList[index].attachId,
            }).then(
                (res) => {
                    if (!useId) {
                        this.docList.splice(index, 1);
                        this.$VMessage.success(res.message);
                    }
                },
                (err) => {
                    if (!useId) {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                }
            );
        },
        close() {
            this.$emit("on-close");
        },
        success() {
            this.close();
            this.$emit("on-update");
        },
    },
};
</script>
